import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/* Single source for the theme cycle; the home page switch uses these too. */
export const THEME_OPTIONS = [
  { value: 'light', icon: Sun, label: 'Light' },
  { value: 'dark', icon: Moon, label: 'Dark' },
  { value: 'system', icon: Monitor, label: 'System' },
];
export const themeOption = (value) => THEME_OPTIONS.find((o) => o.value === value) || THEME_OPTIONS[0];
export const nextTheme = (value) => {
  const i = THEME_OPTIONS.findIndex((o) => o.value === value);
  return THEME_OPTIONS[(i + 1) % THEME_OPTIONS.length].value;
};
const options = THEME_OPTIONS;

export function ThemeToggle({ compact = false }) {
  const { theme, setTheme } = useTheme();

  if (compact) {
    const next = nextTheme(theme);
    const Icon = themeOption(theme).icon;
    return (
      <button
        onClick={() => setTheme(next)}
        className="inline-flex items-center justify-center rounded-md p-2 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
        data-testid="theme-toggle-compact"
        title={`Theme: ${theme}`}
      >
        <Icon size={18} />
      </button>
    );
  }

  return (
    <div className="inline-flex items-center rounded-lg border border-border bg-muted p-0.5 gap-0.5" data-testid="theme-toggle">
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${
            theme === value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          data-testid={`theme-option-${value}`}
        >
          <Icon size={14} />
          {label}
        </button>
      ))}
    </div>
  );
}
